import styled from 'styled-components';
import Background1 from '#assets/img/1.png';
import Background2 from '#assets/img/2.png';
import Background3 from '#assets/img/3.png';
import Background4 from '#assets/img/4.png';
import Background5 from '#assets/img/5.png';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 524px 30px 0 30px;
  @media (max-width: 475px) {
    padding: 320px 30px 0 30px;
  }
`;

export const TextGray = styled.p`
  font-weight: 800;
  font-size: 4.8rem;
  color: var(--gray-300---disabled, #5c576b);
  text-align: center;
  @media (max-width: 475px) {
    font-size: 2.4rem; /* 화면이 475px 이하일 때 폰트 크기 변경 */
  }
`;

export const TextWhite = styled.p`
  font-weight: 800;
  font-size: 4.8rem;
  text-align: center;
  @media (max-width: 475px) {
    font-size: 3.4rem !important; /* 화면이 475px 이하일 때 폰트 크기 변경 */
  }
`;

export const TextGradation = styled.p`
  font-weight: 800;
  font-size: 48px;
  background: linear-gradient(90deg, #6238dd 44.34%, #b098f9 55.47%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 475px) {
    font-size: 2.4rem !important; /* 화면이 475px 이하일 때 폰트 크기 변경 */
  }
`;

export const TextGradationBenefit = styled.p`
  font-weight: 800;
  font-size: 48px;
  background: linear-gradient(90deg, #6238dd 44.34%, #b098f9 55.47%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 475px) {
    font-size: 3.4rem !important; /* 화면이 475px 이하일 때 폰트 크기 변경 */
  }
`;

export const TextGradationFooter = styled.p`
  font-weight: 800;
  font-size: 48px;
  background: linear-gradient(90deg, #6238dd 44.34%, #b098f9 55.47%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @media (max-width: 475px) {
    font-size: 3.4rem !important; /* 화면이 475px 이하일 때 폰트 크기 변경 */
  }
`;

export const GoalTags = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
  margin-top: 92px;
  @media (max-width: 475px) {
    margin-top: 4.6rem;
  }
`;

export const TagsGrid = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  @media (max-width: 475px) {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const GoalTag = styled.p`
  padding: 24px 40px;
  background-color: #1f1e25;
  border-radius: 100px;
  font-size: 24px;
  font-weight: 600;
  span {
    color: #9170f2;
  }
  @media (max-width: 475px) {
    font-size: 1.8rem; /* 화면이 475px 이하일 때 폰트 크기 변경 */
    width: 100%;
    text-align: center;
  }
`;

export const BenefitContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 320px;
  margin-bottom: 240px;
  gap: 100px;
  p {
    font-size: 48px;
    font-weight: 800;
    text-align: center;
  }
  @media (max-width: 475px) {
    margin-top: 160px;
    margin-bottom: 0px;
    gap: 4.6rem;
  }
`;

export const BenefitCardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 6개의 동일한 크기의 열 */
  grid-template-areas:
    'item1 item1 item2 item2'
    'item3 item3 item4 item4';
  gap: 10px;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const BenefitCard = styled.div`
  border-radius: 24px;
  padding: 40px 32px;
  background-color: rgba(119, 80, 233, 0.8);
  display: flex;
  flex-direction: column;
  background-size: 110%;
  p {
    text-align: left;
  }
  .title {
    margin-top: 58px;
    margin-bottom: 20px;
    font-size: 28px;
  }
  .description {
    font-size: 16px;
    font-weight: 400;
  }
`;

export const Item1 = styled(BenefitCard)`
  width: 347px;
  grid-area: item1;
  background-image: url(${Background1});
  @media (max-width: 1024px) {
    width: 87%;
  }
`;

export const Item2 = styled(BenefitCard)`
  width: 347px;
  grid-area: item2;
  background-image: url(${Background2});
  @media (max-width: 1024px) {
    width: 87%;
  }
`;

export const Item3 = styled(BenefitCard)`
  width: 347px;
  grid-area: item3;
  background-image: url(${Background3});
  @media (max-width: 1024px) {
    width: 87%;
  }
`;

export const Item4 = styled(BenefitCard)`
  width: 347px;
  grid-area: item4;
  background-image: url(${Background4});
  @media (max-width: 1024px) {
    width: 87%;
  }
`;

export const Item5 = styled(BenefitCard)`
  width: 530px;
  grid-area: item5;
  background-image: url(${Background5});
  @media (max-width: 1024px) {
    width: 87%;
    background-size: 160%;
  }
`;

export const LandingTopFooter = styled.div`
  width: 120%;
  height: 640px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    180deg,
    rgba(119, 80, 233, 0) 0%,
    rgba(119, 80, 233, 0.2) 100%
  );
  p {
    text-align: center;
    font-size: 64px;
    @media (max-width: 475px) {
      font-size: 32px;
    }
  }
  @media (max-width: 475px) {
    height: 100%;
    padding: 120px 0 60px;
  }
`;
